import type { PodcastPlatform } from "../types";

export function PodcastPlatformIcon({
  kind,
  size = "default",
}: {
  kind: PodcastPlatform["kind"];
  size?: "default" | "large";
}) {
  const className =
    size === "large" ? "!h-[21px] !w-[21px] shrink-0" : "!h-[18px] !w-[18px] shrink-0";

  if (kind === "spotify") {
    return (
      <svg
        viewBox="0 0 24 24"
        className={`${className} text-[#1DB954]`}
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M12 1.25A10.75 10.75 0 1 0 12 22.75 10.75 10.75 0 0 0 12 1.25Zm4.93 15.53a.72.72 0 0 1-.99.24c-2.71-1.66-6.12-2.03-10.13-1.11a.72.72 0 1 1-.32-1.41c4.4-1 8.16-.57 11.2 1.28.34.21.45.65.24 1Zm1.4-3.13a.9.9 0 0 1-1.24.3c-3.1-1.9-7.82-2.46-11.49-1.35a.9.9 0 1 1-.52-1.73c4.19-1.27 9.4-.65 12.95 1.53.42.26.55.82.3 1.25Zm.12-3.25C14.73 8.19 8.6 8 5.05 9.02a1.08 1.08 0 1 1-.6-2.07c4.08-1.18 10.85-.94 15.11 1.58a1.08 1.08 0 0 1-1.1 1.87Z" />
      </svg>
    );
  }

  if (kind === "apple") {
    return (
      <svg
        viewBox="0 0 24 24"
        className={`${className} text-[#9933CC]`}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M6.15 17.85a8.25 8.25 0 1 1 11.7 0" strokeWidth="1.55" />
        <path d="M8.5 15.4a5.25 5.25 0 1 1 7 0" strokeWidth="1.55" />
        <circle cx="12" cy="8.7" r="1.65" fill="currentColor" stroke="none" />
        <path
          d="M9.9 13.1a2.1 2.1 0 0 1 4.2 0c0 .83-.4 1.47-.86 2l-.55 5.15h-1.38l-.55-5.15c-.46-.53-.86-1.17-.86-2Z"
          fill="currentColor"
          stroke="none"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      className={`${className} text-[#FF0000]`}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M23.25 7.1a3.02 3.02 0 0 0-2.13-2.14C19.23 4.45 12 4.45 12 4.45s-7.23 0-9.12.51A3.02 3.02 0 0 0 .75 7.1 31.4 31.4 0 0 0 .25 12a31.4 31.4 0 0 0 .5 4.9 3.02 3.02 0 0 0 2.13 2.14c1.89.51 9.12.51 9.12.51s7.23 0 9.12-.51a3.02 3.02 0 0 0 2.13-2.14 31.4 31.4 0 0 0 .5-4.9 31.4 31.4 0 0 0-.5-4.9ZM9.65 15.25v-6.5L15.75 12l-6.1 3.25Z" />
    </svg>
  );
}
